import React from 'react';
import { Chip, Grid, Typography } from '@material-ui/core';
import { Entity } from '@backstage/catalog-model';
import { CardTitle, CardTitleOptions } from '../CardTitle';
import { InfoCard } from '@backstage/core-components';
import { GridActions } from '../GidActions';
import {
  EntityTagFilter,
  useEntityList,
} from '@backstage/plugin-catalog-react';
import { CatalogGridAction } from '../GidActions/GridActions';
import { CatalogGridItem } from '../types';
import { extractTagName, subheaderForEntity } from './helpers';
import { useCatalogCardIconStyles } from './styles';

export function DefaultCardItem<T extends CatalogGridItem>({
  row,
  options,
  actions,
  queryParamTags,
  defaultActions,
}: {
  row: { entity: Entity };
  options?: CardTitleOptions;
  actions?: CatalogGridAction<T>[];
  queryParamTags: string[];
  defaultActions?: any;
}) {
  const classes = useCatalogCardIconStyles();
  const { updateFilters, filters, queryParameters } = useEntityList();

  return (
    <InfoCard
      title={<CardTitle entity={row.entity} options={options} />}
      subheader={subheaderForEntity(
        row.entity,
        updateFilters,
        filters,
        classes,
      )}
      actions={<GridActions actions={actions || defaultActions} row={row} />}
      className={classes.card}
      cardClassName={classes.cardContent}
    >
      <Typography className={classes.description}>
        {row.entity.metadata?.description}
      </Typography>

      {row.entity?.metadata?.tags && (
        <Grid>
          {(row.entity?.metadata?.tags || []).map(t => {
            const tag = extractTagName(t);
            return (
              <Chip
                key={tag.key}
                size="small"
                label={tag.label}
                onClick={() => {
                  queryParameters.tags = [...new Set([...queryParamTags, t])];
                  updateFilters({
                    tags: new EntityTagFilter([
                      ...new Set(filters.tags?.values?.concat([t]) || [t]),
                    ]),
                  });
                }}
              />
            );
          })}
        </Grid>
      )}
    </InfoCard>
  );
}
